
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import UploadingPage from './UploadingPage';
import LandingPage from './LandingPage';
import DashboardPage from './DashboardPage';
import { ThemeProvider } from './ThemeContext';


function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
     
          <Route path="/login" element={<LoginPage />} />
          <Route path="/upload" element={<UploadingPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/" element={<LandingPage />} />

          {/* Add more routes here as needed */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
